<ng-container *ngFor="let entry of entries">
    <p-dialog #dialog styleClass="note-controller-dialog" (injector)="registerDialog(dialog, entry, $event)"
              transitionOptions="0ms" [visible]="true" [closable]="false"
              appendTo="body" [style]="entry.dialogSettings.style">
        <ng-template pTemplate="header">
            <div lb-events (onDestroy)="unregisterDialog(dialog)" class="p-grid p-nogutter">
                <div (onResize)="adjustDialogHeaderSizing($event)" class="dialog-header-title p-d-flex p-jc-start p-ai-center p-col-6 whitespace-pre-line">
                    {{getWindowName(entry)}}
                </div>
                <div class="p-col-6 p-d-flex p-jc-end p-ai-start p-text-right">
                    <button *ngIf="!controlService.shouldUseMobileView()" pButton class="p-button-text p-button-secondary" title="More Options" icon="fa fa-ellipsis-v" (click)="showOverFlowMenu(overflowMenu, dialog, $event)"></button>
                    <button pButton class="p-button-text p-button-secondary p-mr-1" title="Send to Enter Notes" icon="fa fa-window-maximize" (click)="controlService.sendToEnterNotes(entry)"></button>
                    <button pButton class="p-button-text p-button-secondary" title="Minimize" icon="fa fa-window-minimize" (click)="controlService.sendToBar(entry, true)"></button>
                    <button pButton class="p-button-text p-button-secondary" title="Dock" icon="fa fa-compress" (click)="controlService.sendToBar(entry)"></button>
                    <button pButton class="p-button-text p-button-secondary" title="Close" icon="fa fa-times" (click)="controlService.destroy(entry)"></button>
                </div>
            </div>
        </ng-template>
        <div style="width: 100%; height: inherit">
            <ng-container (container)="viewContainerReady($event, entry)"></ng-container>
        </div>
    </p-dialog>
    <p-menu #overflowMenu [popup]="true" appendTo="body"></p-menu>
</ng-container>

<div class="bottom-bar-container p-d-flex p-jc-end p-ai-end">
    <button pButton title="Show more notes in progress" icon="pi pi-bars" class="overflow-button p-button-secondary p-button-rounded" *ngIf="hiddenEntries.length" (click)="inProgressVisible = true"></button>
    <ng-container *ngFor="let entry of minimizedEntries">
        <p-accordion class="note-control-tab p-shadow-24">
            <p-accordionTab #accordionTab lb-events (afterViewInit)="registerTab(accordionTab)" [(selected)]="entry.barSettings.maximized">
                <ng-template pTemplate="header">
                    <div class="p-grid p-nogutter w-100">
                        <div class="p-col-6 whitespace-pre-line">
                            {{getWindowName(entry)}}
                        </div>
                        <div class="p-col-6 p-text-right">
                            <button pButton class="p-button-text p-button-secondary p-ml-1" title="Send to Enter Notes" icon="fa fa-window-maximize" (click)="controlService.sendToEnterNotes(entry)"></button>
                            <button pButton class="minimize-button p-button-text p-button-secondary" title="Pop out to floating window" icon="fa fa-expand" (click)="controlService.sendToDialog(entry)"></button>
                            <button pButton class="p-button-text p-button-secondary" [title]="entry.barSettings.maximized ? 'Minimize' : 'Maximize'" [icon]="'fa fa-' + (entry.barSettings.maximized ? 'window-minimize' : 'angle-up fa-lg')" (click)="entry.barSettings.maximized = !entry.barSettings.maximized"></button>
                            <button pButton class="p-button-text p-button-secondary" title="Close" icon="fa fa-times" (click)="controlService.destroy(entry)"></button>
                        </div>
                    </div>
                </ng-template>
                <div class="note-control-body" [style]="{ maxWidth: noteBarWidth, width: noteBarWidth }">
                    <ng-container (container)="viewContainerReady($event, entry)"></ng-container>
                </div>
            </p-accordionTab>
        </p-accordion>
    </ng-container>
</div>

<p-dialog appendTo="body" [(visible)]="inProgressVisible" header="In Progress Notes" [modal]="true" [style]="{ width: '750px' }">
    <p-table [value]="hiddenEntries">
        <ng-template pTemplate="body" let-value let-index="rowIndex">
            <tr class="clickable" (click)="controlService.unhideEntry(index); inProgressVisible = false">
                <td>{{getWindowName(value)}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-confirmDialog key="dialog-save-settings" styleClass="save-dialog" header="Save Settings"></p-confirmDialog>




